import React from "react";

// Official MELLETIC mark — one unified blue "M" (ribbon flowing into its spherical endpoint).
// Recoloured to a single blue material via mask-over-gradient so it matches everywhere.
export default function Logo({ size = 40, showText = false, textClass = "", light = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="melletic-logo">
      <div
        aria-label="MELLETIC"
        style={{
          height: size, width: size * (490 / 243),
          WebkitMaskImage: "url(/melletic-mark.png)", maskImage: "url(/melletic-mark.png)",
          WebkitMaskSize: "contain", maskSize: "contain",
          WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
          WebkitMaskPosition: "center", maskPosition: "center",
          background: "linear-gradient(135deg, #bcddff 0%, #6aa6f7 30%, #2f6fe0 62%, #17368f 100%)",
          filter: "drop-shadow(0 3px 6px rgba(23,42,110,0.35)) drop-shadow(0 -1px 0 rgba(255,255,255,0.5))",
        }}
        className="select-none block shrink-0"
      />
      {showText && (
        <span className={`font-heading font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"} ${textClass}`}>
          MELLETIC
        </span>
      )}
    </div>
  );
}
